import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { SectionCardInfoData } from '@fcp/lib-ui';
import { CardInfoContainerService } from './card-info-container.service';

@Component({
  selector: 'fcp-card-info-container',
  template: `
    <fcp-section-card-info
      [sectionCardInfo]="data | async"
      (clicked)="clicked.emit($event)"
    ></fcp-section-card-info>
  `
})
export class CardInfoContainerComponent implements OnInit {
  @Input() public id: string;
  @Output() public clicked: EventEmitter<any> = new EventEmitter();
  public data: Observable<SectionCardInfoData>;
  constructor(private cardInfoContainerService: CardInfoContainerService) {}

  ngOnInit() {
    this.data = this.cardInfoContainerService.getInformativo(this.id);
  }
}
